module.exports = __webpack_public_path__ + "static/media/10.151e4148.jpg";